<template>
    <img v-lazy="li.ImgUrl" class="van_img"/>
</template>
<script>
export default {
    data() {
        return{
          li:null,
        }
    },
    props:['swipe'],
    watch:{
      swipe:{
        handler(newName, oldName) {
          this.li=newName

        },
      deep: true,
      immediate: true
      }
    }
}
</script>
<style lang="scss" scoped>
  .van_img{
      width: 100%;
      height: 100%;
      border-radius: 0.5rem;
  }
</style>




// WEBPACK FOOTER //
// src/components/banner.vue